<script setup lang="ts">
const {
	data: siteData,
	error: siteError,
	refresh,
} = await useFetch('/api/site-data', {
	key: 'site-data',
});

const { isVisualEditingEnabled, apply } = useVisualEditing();

const route = useRoute();
const navigation = useTemplateRef('navigationRef');
const footer = useTemplateRef('footerRef');

// Controlla se la pagina corrente ha fullscreen_display abilitato
const pageFullscreenDisplay = useState('pageFullscreenDisplay', () => false);

// Controlla se la navbar è trasparente (condiviso dalla NavigationBar)
const navbarTransparent = useState('navbarTransparent', () => false);
// Controlla se il menu mobile è aperto (condiviso dalla NavigationBar)
const menuOpen = useState('menuOpen', () => false);
// Controlla se la navbar è ancora in caricamento iniziale (condiviso dalla NavigationBar)
// Per le route di autenticazione, inizializza a false per evitare mismatch di hydration
const isAuthPage = computed(() => {
	const authRoutes = ['/login', '/forgot-password', '/reset-password', '/area-riservata'];
	return authRoutes.some(authRoute => route.path.startsWith(authRoute));
});
const navbarInitialLoad = useState('navbarInitialLoad', () => isAuthPage.value ? false : true);

if (siteError.value) {
	throw createError({
		statusCode: 500,
		statusMessage: 'Failed to load site data. Please try again later.',
		fatal: true,
	});
}

useHead({
	link: [
		{
			rel: 'stylesheet',
			href: 'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200',
		},
	],
	style: [
		{
			id: 'accent-color',
			innerHTML: `:root { --accent-color: ${unref(siteData)?.globals?.accent_color || '#6644ff'} !important; }`,
		},
	],
	bodyAttrs: {
		class: 'antialiased font-sans overflow-x-hidden',
	},
});

useSeoMeta({
	titleTemplate: `%s / ${unref(siteData)?.globals?.title || 'WeFocus'}`,
	ogSiteName: unref(siteData)?.globals?.title || 'WeFocus',
});

onMounted(() => {
	if (!isVisualEditingEnabled.value) return;
	apply({
		elements: [navigation.value?.navigationRef as HTMLElement, footer.value?.footerRef as HTMLElement],
		onSaved: () => {
			refresh();
		},
	});
});
</script>

<template>
	<div>
	<NavigationBar
		v-if="siteData?.headerNavigation && siteData?.globals && !pageFullscreenDisplay"
		ref="navigationRef"
		:navigation="siteData.headerNavigation"
		:globals="siteData.globals"
	/>
		<div :class="{ 
			'pt-[80px]': (siteData?.headerNavigation && siteData?.globals && !pageFullscreenDisplay && !navbarTransparent && !menuOpen && !navbarInitialLoad) || 
				(isAuthPage && siteData?.headerNavigation && siteData?.globals && !pageFullscreenDisplay && !menuOpen),
		}">
			<NuxtPage />
		</div>
	<Footer
		v-if="siteData?.footerNavigation && siteData?.globals && !pageFullscreenDisplay"
		ref="footerRef"
		:navigation="siteData.footerNavigation"
		:globals="siteData.globals"
	/>
	<ChatWidget v-if="!pageFullscreenDisplay" :globals="siteData?.globals" />
	</div>
</template>
